
import { ApplicationSourceEnum } from '../../dto/applicationSource.enum';

export const OTHER_APP_SOURCES = [
  ApplicationSourceEnum.OTHER,
  ApplicationSourceEnum.MOBILE_ANDROID,
  ApplicationSourceEnum.MOBILE_IOS
];
